import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Section } from 'src/app/entities/section';
import { SectionService } from 'src/app/services/section.service';
import { AlertService } from 'src/app/services/alert.service';
import { BaseTableComponent } from '../base-table/base-table.component';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SectionComponent extends BaseTableComponent<Section> implements OnInit {

  displayedColumns = ['id', 'slug', 'title', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'slug',
      field_key: 'slug',
      type: 'string',
      title: 'Slug',
      classes: ''
    },
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
  ];

  constructor(
    protected sectionService: SectionService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = sectionService;
  }

  ngOnInit(): void {
    this.loadItems();
  }

}